import { Step } from "./Step";
import { CreditableExam } from "./CreditableExam";
import { StepTypes } from "../../enum/StepTypes";
import { MultiLanguage } from "../../MultiLanguage";

 export class ExamStep extends Step {
    private _id: string;
    private _description: MultiLanguage;
    private _creditableExams: CreditableExam[];

    constructor(step: any) {
        super(step);
        this._id = step.id;
        this._name = StepTypes.translations[step.type].name ;
        this._description = new MultiLanguage(step.description);
        this._creditableExams = step.creditableExams.map( creditableExam => new CreditableExam(creditableExam));
    }

    public get id() {
        return this._id;
    }
    public set id(id: string) {
        this._id = id;
    }
    public get description() {
        return this._description;
    }
     public set description(value: MultiLanguage) {
        this._description = value;
    }
    public get creditableExams(): CreditableExam[] {
        return this._creditableExams;
    }
    public toServer() {
        let examCreditableToServe= this.creditableExams.map(element => element.toServer());
        return {
            id: this._id,
            creditableExams: examCreditableToServe,
        }
    }
}
